<template>
  <header class="header">
    <div class="header-left">
      <span class="logo" @click="goIndex">He Zou</span>
    </div>
    
    <nav class="header-nav">
      <router-link to="/" class="nav-item" active-class="active">首页</router-link>
      <router-link to="/community" class="nav-item" active-class="active">社区</router-link>
      <router-link to="/message" class="nav-item" active-class="active">
        消息
        <el-badge :value="unreadCount" :hidden="unreadCount === 0" class="message-badge"/>
      </router-link>
    </nav>

    <div class="header-right">
      <template v-if="!isLogin">
        <el-button class="btn-text" @click="goLogin">登录</el-button>
        <el-button type="primary" class="btn-primary" @click="goSignUp">注册</el-button>
      </template>
      <template v-else>
        <div class="user-menu">
          <div class="user-avatar" @click="toggleDropdown">
            <el-avatar :size="36" :src="userAvatar" icon="el-icon-user-solid"></el-avatar>
            <span class="username">{{ currUsername }}</span>
            <i class="el-icon-arrow-down arrow"></i>
          </div>
          <transition name="dropdown-fade">
            <div v-show="dropdownVisible" class="dropdown-menu">
              <div class="dropdown-item" v-if="isAdmin" @click="goAdmin">
                <i class="el-icon-s-management"></i>
                <span>管理后台</span>
              </div>
              <div class="dropdown-item" @click="goProfile">
                <i class="el-icon-user"></i>
                <span>个人中心</span>
              </div>
              <div class="dropdown-item" @click="goLogout">
                <i class="el-icon-switch-button"></i>
                <span>退出登录</span>
              </div>
            </div>
          </transition>
        </div>
      </template>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeadBar",
  data() {
    return {
      dropdownVisible: false,
      unreadCount: 0,
      unreadTimer: null
    };
  },
  created() {
    this.$store.commit("init");
    if (this.isLogin) {
      this.getUnreadCount();
      this.unreadTimer = setInterval(() => {
        this.getUnreadCount();
      }, 30000);
    }
    // 监听消息标记已读事件
    this.$on('updateUnreadCount', (count) => {
      this.unreadCount = count;
    });
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    currUsername() {
      return this.$store.state.loginResult.userName || '';
    },
    userAvatar() {
      return this.$store.state.loginResult.icon || '';
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    closeDropdown() {
      this.dropdownVisible = false;
    },
    goIndex() {
      this.$router.push({ name: "Home" });
    },
    goLogin() {
      this.$router.push({ name: "Login" });
    },
    goSignUp() {
      this.$router.push({ name: "SignUp" });
    },
    goProfile() {
      this.$router.push({ name: "UserCenter" });
      this.closeDropdown();
    },
    goAdmin() {
      this.$router.push({ name: "Admin" });
      this.closeDropdown();
    },
    goLogout() {
      this.$store.commit("logout");
      this.$notify({
        title: "成功",
        message: "已退出登录",
        type: "success",
        offset: 100,
        position: 'bottom-right'
      });
      this.closeDropdown();
    },
    async getUnreadCount() {
      if (!this.isLogin) return;
      try {
        const loginResult = JSON.parse(localStorage.getItem('loginResult') || '{}');
        const response = await this.$axios({
          method: 'post',
          url: '/message/unreadCount',
          data: {
            token: loginResult.token || '',
            userId: loginResult.userId || '',
            userName: loginResult.userName || '',
            ip: '',
            source: 'web'
          }
        });
        if (response.code === '200' || response.code === 200) {
          this.unreadCount = response.data || 0;
        }
      } catch (error) {
        console.error('获取未读消息失败:', error);
      }
    },
    goMessage() {
      this.$router.push({ name: "Message" });
      this.unreadCount = 0;
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.getUnreadCount();
        this.unreadTimer = setInterval(() => {
          this.getUnreadCount();
        }, 30000);
      } else {
        this.unreadCount = 0;
        if (this.unreadTimer) {
          clearInterval(this.unreadTimer);
          this.unreadTimer = null;
        }
      }
    }
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.closeDropdown();
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
    if (this.unreadTimer) {
      clearInterval(this.unreadTimer);
    }
  }
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  height: 64px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  z-index: 1000;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  .header-left {
    display: flex;
    align-items: center;

    .logo {
      height: 32px;
      background: url("../assets/images/mini_xs.png") no-repeat;
      background-size: 32px 32px;
      background-position: left center;
      padding-left: 35px;
      line-height: 32px;
      cursor: pointer;
      font-weight: 600;
      font-size: 18px;
      color: #333;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .header-nav {
    display: flex;
    align-items: center;
    gap: 8px;

    .nav-item {
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 500;
      color: #666;
      text-decoration: none;
      border-radius: 8px;
      transition: all 0.2s;
      position: relative;

      &:hover {
        background: rgba(102, 126, 234, 0.08);
        color: #667eea;
      }

      &.active {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
      }

      .message-badge {
        margin-left: 6px;
        ::v-deep .el-badge__content {
          border: 2px solid #fff;
        }
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .btn-text {
      border: none;
      background: transparent;
      color: #666;
      font-weight: 500;
      padding: 8px 16px;

      &:hover {
        color: #667eea;
        background: rgba(102, 126, 234, 0.08);
      }
    }

    .btn-primary {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: none;
      padding: 8px 24px;
      font-weight: 500;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
      transition: all 0.2s;

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
      }
    }

    .user-menu {
      position: relative;

      .user-avatar {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 12px 6px 6px;
        border-radius: 24px;
        cursor: pointer;
        transition: all 0.2s;
        border: 2px solid transparent;

        &:hover {
          background: rgba(102, 126, 234, 0.08);
          border-color: rgba(102, 126, 234, 0.3);
        }

        .username {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .arrow {
          font-size: 12px;
          color: #999;
          transition: transform 0.2s;
        }
      }

      .dropdown-menu {
        position: absolute;
        top: calc(100% + 8px);
        right: 0;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        padding: 8px;
        min-width: 160px;
        z-index: 1001;
        overflow: hidden;

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 14px;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          border-radius: 8px;
          transition: all 0.2s;

          i {
            font-size: 16px;
            color: #999;
          }

          &:hover {
            background: rgba(102, 126, 234, 0.08);
            color: #667eea;

            i {
              color: #667eea;
            }
          }
        }
      }
    }
  }
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s ease;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

@media (max-width: 768px) {
  .header {
    padding: 0 16px;

    .header-nav {
      display: none;
    }
  }
}
</style>
